import React, { useState } from "react";
import styles from "./Modal.module.css";
import axios from "../../services/axiosInstance";
import { SquareX} from "lucide-react";

const ModalAlterarSenha = ({ show, onClose, onSuccess }) => {
  const [senhaAtual, setSenhaAtual] = useState("");
  const [novaSenha, setNovaSenha] = useState("");
  const [confirmar, setConfirmar] = useState("");
  const [loading, setLoading] = useState(false);

  if (!show) return null;

  const salvar = async (e) => {
    e.preventDefault();
    if (novaSenha !== confirmar) return alert("Confirmação de senha não confere.");
    setLoading(true);
    try {
      await axios.post('/usuarios/alterar-senha', { senhaAtual, novaSenha });
      alert("Senha alterada.");
      onSuccess?.();
    } catch (e) {
      alert(e?.response?.data?.message || "Erro ao alterar senha.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modal} style={{ maxWidth: 420, height: "auto" }}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>Alterar Senha</h2>
          <button className={styles.modalClose} onClick={onClose}><SquareX /></button>
        </div>
        <form onSubmit={salvar} className={styles.gridForm} style={{color: "#555"}}>
        <div>
          <label>Senha atual</label>
          <input className={styles.inputBusca} type="password" value={senhaAtual} onChange={e => setSenhaAtual(e.target.value)} required />
        </div>
       <div>
          <label>Nova senha</label>
          <input className={styles.inputBusca} type="password" value={novaSenha} onChange={e => setNovaSenha(e.target.value)} required />
        </div>
        <div>
          <label>Confirmar nova senha</label>
          <input className={styles.inputBusca} type="password" value={confirmar} onChange={e => setConfirmar(e.target.value)} required />
        </div>
          <div className={styles.botoesAcaoBlocos}>
            <button className={styles.iniciarVotacao} type="submit" disabled={loading}>Salvar</button>
            <button className={styles.encerrarVotacao} type="button" onClick={onClose}>Cancelar</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ModalAlterarSenha;
